import { BaseApiService } from '../base/BaseApiService';

export enum ECqvRequestStatus {
  Pendente = 0,
  AprovadoNoPrazo = 1,
  RecusadoManual = 2,
}

export enum ECqvRejectionSource {
  Manual = 0,
  ReplyWhatsApp = 1,
  ReplyTelegram = 2,
}

/** Como a CQV vai ser feita com o cliente — muda o SLA (Ligação: 10min, WhatsApp: 30min). */
export enum ECqvRequestMode {
  Ligacao = 0,
  WhatsApp = 1,
}

export const CQV_REQUEST_MODE_LABELS: Record<ECqvRequestMode, string> = {
  [ECqvRequestMode.Ligacao]: 'Ligação',
  [ECqvRequestMode.WhatsApp]: 'WhatsApp',
};

export interface CqvRequestResponseDto {
  id: string;
  contractId: string;
  requestedAt: string;
  slaDeadline: string;
  status: ECqvRequestStatus;
  mode: ECqvRequestMode;
  whatsAppSent: boolean;
  whatsAppError?: string | null;
  telegramSent?: boolean;
  telegramError?: string | null;
  telegramMessageId?: string | null;
  agente3CAgentId?: number | null;
  agente3CRamal?: number | null;
  resendOfId?: string | null;
  rejectionReason?: string | null;
  rejectionSource?: ECqvRejectionSource | null;
}

/**
 * Solicitação automática de CQV com SLA de 10min.
 * Ver specs/solicitacao-cqv-automatica-sla/about.md.
 */
export class CqvRequestService extends BaseApiService {
  async requestCqv(
    contractId: string,
    resendOfId?: string,
    mode?: ECqvRequestMode
  ): Promise<CqvRequestResponseDto> {
    const response = await this.api.post<CqvRequestResponseDto>(`/v1/contracts/${contractId}/cqv-requests`, {
      ...(resendOfId ? { resendOfId } : {}),
      ...(mode !== undefined ? { mode } : {}),
    });
    return response.data;
  }

  /** Histórico do contrato, mais recente primeiro — usado pra saber se há recusa a reenviar (T12). */
  async getHistory(contractId: string): Promise<CqvRequestResponseDto[]> {
    const response = await this.api.get<CqvRequestResponseDto[]>(`/v1/contracts/${contractId}/cqv-requests`);
    return response.data;
  }

  /** Métricas agregadas (AC#7) — página de orquestração VTME. */
  async getMetrics(): Promise<CqvRequestMetricsDto> {
    const response = await this.api.get<CqvRequestMetricsDto>('/v1/cqv-requests/metrics');
    return response.data;
  }
}

export interface CqvRequestMetricsDto {
  totalRequests: number;
  pending: number;
  approvedOnTime: number;
  rejectedManual: number;
  rejectedViaWhatsAppReply: number;
  slaOverdueAlertsSent: number;
  averageMinutesToApproval?: number | null;
}

export const cqvRequestService = new CqvRequestService();
